import React, { useEffect, useContext, useState } from 'react'
import UserContext from 'contexts/UserContext'
import classNames from 'classnames'
import { Spinner } from 'utils/loading'

import PartnerCard from 'containers/pointColectContainer/partnerCard'
import ListeCarteBancairePage from './listeCarteBancairePage'
import { useNavigate } from 'react-router-dom'
import ModalTestStatusUser from 'components/modalTestStatusUser'
import PointDeCollectMaroc from './pointDeCollectMaroc'
import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'
import { getListByCity, getListByCountry, getListByGovernorate } from 'requests/transfer'
import InputSelectComponent from 'components/inputSelectComponent'

interface City {
  id: number
  value: string
}

interface props {
  setColectPointId: (value: string) => void
  setNumStep: (value: number) => void
  // idBeneficiary: any
  // apiData: any
  colectPointId: any
  // setChoisirCarte?: (value: any) => void
  // choisirCarte?: string
  banqueName: any
  setBanqueName: (value: string) => void
  iban: any
  setIban: (value: string) => void
  setSelectedOptionReseaux: (value: string) => void
  setSelectedBnfList: (value: any) => void
  selectedBnfList: any
  bnfidentifiant: any
  setBnfidentifiant: (value: any) => void
  bankcode: any
  setBankcode: (value: any) => void
  swiftBic: any
  setSwiftBic: (value: any) => void
  pathCode?: any
  valuePays: any
  setNetworkChecked: (value: string) => void
  euroValue: any
  functionTracks: any
  selectedOptionReseaux: string
  country:string
}
function containsObject(name: string, list: any) {
  if (list.length > 0) {
    var i
    for (i = 0; i < list.length; i++) {
      if (list[i].name === name) {
        return true
      }
    }
  }
  return false
}


const PointCollecte: React.FC<props> = ({
  setColectPointId,
  setNumStep,
  // idBeneficiary,
  // apiData,
  colectPointId,
  // setChoisirCarte,
  // choisirCarte ,
  banqueName,
  setBanqueName,
  iban,
  setIban,
  setSelectedOptionReseaux,
  setSelectedBnfList,
  selectedBnfList,
  bnfidentifiant,
  setBnfidentifiant,
  bankcode,
  setBankcode,
  swiftBic,
  setSwiftBic,
  pathCode,
  valuePays,
  setNetworkChecked,
  euroValue,
  functionTracks,
  selectedOptionReseaux,
  country
}) => {
  const { user } = useContext(UserContext)
  const { TransferData, setTransferData } = useContext(transferBeneficiaryContext)
  const navigate = useNavigate()
  const [openGovernorate, setOpenGovernorate] = useState(false)
    const [openVille, setOpenVille] = useState(false)
  

  const [loading, setLoading] = useState(false)
  const [valueVille, setValueVille] = useState('')
  const [openIsModalStatus, setOpenIsModalStatus] = useState(false)
  const [selectedOptionPointCollecte, setSelectedOptionPointCollecte] = useState('')
  //get Governorate
  const [getListGovernorate, setGetListGovernorate] = useState<City[]>([])
  const [getGovernorate, setGovernorate] = useState('')
  //get City
  const [getListCity, setGetListCity] = useState<City[]>([])
  const [getCity, setGetCity] = useState('')

  //get partenaire
  const [getListPartenaireByCity, setListPartenaireByCity] = useState([])

  //test status user
  const statusComplete = user?.user?.status === 'confirmed' && user?.user?.isDocumentSent
  const statusPending = user?.user?.status === 'pending' && user?.user?.isDocumentSent
  const statusNotFound = user?.user?.status === 'pending' && !user?.user?.isDocumentSent


  const openModalStatus = () => {
    setOpenIsModalStatus(true)
  }
  const closeModalStatus = () => {
    setOpenIsModalStatus(false)
  }

  
      useEffect(() => {
    if (TransferData && valuePays.value==='TND') {
      setGovernorate(TransferData?.governorate || '')
      setGetCity(TransferData.ville || '')
    }
  }, [])

  useEffect(() => {

    async function functionGetListByCountry() {
      
      try {
        const response = await getListByCountry(country, euroValue)

        if (response?.success === true) {
          const liste = response?.partners[0]?.governorate 
          setGetListGovernorate(liste.map((item:string, index: number)=>({
            id:index,
            value:item
          })) )
      
        } else {
          console.error('response failed', response)
        }
        setLoading(true)
      } catch (error) {
        console.error(error)
      }
    }
    if (valuePays.value ==='TND' && pathCode==='0') 
      functionGetListByCountry()
    else setLoading(true)
  }, [])


  //get list city by Governorate
  useEffect(() => {
     const functionGetListByGovernorate = async () => {
    try {

      const response = await getListByGovernorate(country, euroValue, getGovernorate)
      if (response?.success === true) {
      const liste = response?.partners[0]?.cities 
        setGetListCity(liste.map((item:any, index:number)=>({
          id:index,
          value:item
        })))
      } else {
        console.error('response failed', response)
      }
      setLoading(true)
    } catch (error) {
      console.error(error)
    }
  }
    if (getGovernorate) {
      functionGetListByGovernorate()
    }
  }, [getGovernorate])

 
 
  //getListPartenaireByCity.filter((item: any) => item.network === 'izi' || 'Viamobile')
 //get list city by City
  useEffect(() => {

    const functionGetListByCity = async () => {
    try {
      const response = await getListByCity(country, euroValue, getGovernorate, getCity)
      if (response?.success === true) {
       
        setListPartenaireByCity(response.partners)
      } else {
        console.error('response failed', response)
      }
      setLoading(true)
    } catch (error) {
      console.error(error)
    }
  }
    if (getCity) {
      functionGetListByCity()
    }
  }, [getCity])

 
  // const fnChangeValueVille = (value: string) => {
  //   setValueVille(value)
  //   setTransferData({ ...TransferData, ville: value })
  // }

   const handleSelectedGouvernerat= (item:any)=>{
                setGovernorate(item.value)
                setOpenGovernorate(false)
                if (item !== getGovernorate) {
                  setListPartenaireByCity([])
                  setGetCity('')
                  setTransferData({ ...TransferData, governorate: item.value, ville: '', partenaire: '', pointDeCollect: '' })
                }
  }
  const handleSelectedVille=(item:any)=>{
                if (item.value !== getCity) {
                setGetCity(item.value)

                  setListPartenaireByCity([])
                  setSelectedOptionReseaux('')
                  setSelectedOptionPointCollecte('')
                  setTransferData({ ...TransferData, ville: item.value, partenaire: '', pointDeCollect: '' })
                }
  }

  if (!loading) return <Spinner name="line-scale-pulse-out-rapid" color="#1466ff" />
  return (
    <div className="mb-10">
      {
        pathCode === '0' ?
          (
            valuePays?.value !== 'TND'?
            <PointDeCollectMaroc
              setNumStep={setNumStep}
              setNetworkChecked={(value) => setNetworkChecked(value)}
              functionTracks={functionTracks}
              valuePays={valuePays.value}
            />
            :
            <div className='xl:w-full'>
              <div className=" w-full space-y-6 ">

                 <InputSelectComponent
                  liste={[...getListGovernorate].sort((a,b)=>a.value.localeCompare(b.value))}
                  isOpen={openGovernorate}
                  setIsOpen={setOpenGovernorate}
                  value={getGovernorate}
                  setValue={setGovernorate}
                  placeholder='Choisir'
                  label='Gouvernorat'
                  handleClick={handleSelectedGouvernerat}
                  messageIsEmpty='Aucunne Gouvernorat ajouté pour le moment'
                />
               
                <InputSelectComponent
                    liste={[...getListCity].sort((a,b)=>a.value.localeCompare(b.value))}
                    isOpen={openVille}
                    setIsOpen={setOpenVille}
                    value={getCity}
                    setValue={setGetCity}
                    placeholder='Choisir'
                    label='Ville'
                    handleClick={handleSelectedVille}
                    messageIsEmpty='cursor-not-allowed'
                  />

                 
                <PartnerCard
                  selectedOptionPointCollecte={selectedOptionPointCollecte}
                  setSelectedOptionPointCollecte={setSelectedOptionPointCollecte}
                  setColectPointId={setColectPointId}
                  euroValue={euroValue}
                  colectPointId={colectPointId}
                  selectedOptionReseaux={selectedOptionReseaux}
                  setSelectedOptionReseaux={setSelectedOptionReseaux}
                  getListPartenaireByCity={getListPartenaireByCity}
                />
              </div>
              <div className="flex gap-[16px] mt-[25px] justify-center w-full h-[56px] sm:px-4 font-semibold font-roboto ">

                  <button
                    className={classNames(
                        'text-[18px] text-[#5754E5]  hover:border-[#4D36CC] hover:bg-[#F1F1FF] border border-[#5754E5] w-[180px] sm:w-[140px] font-sans rounded-[16px]',

                    )}
                    onClick={() => {
                      setNumStep(1)
                    }}
                  >
                    Précédent
                  </button>

                  <button
                    className={classNames(
                      !TransferData?.pointDeCollect

                    
                        ? 'bg-[#D1D1FF] hover:cursor-not-allowed'
                        : 'bg-[#5754E5]  hover:bg-[#4D36CC]',
                        'text-[18px] text-[#FFF]  sm:w-[170px]  rounded-[16px] w-[375px]  ',
                        )}
                    onClick={() => {
                      if (statusComplete) {
                       
                        setNumStep(3)
                        functionTracks('3')
                      } else if (statusPending) {
                       
                        openModalStatus()
                      } else if (statusNotFound) {
                      
                        navigate('/personalinformation')
                      }
                    }}
                    disabled={ TransferData?.pointDeCollect === ''}
                  >
                    Suivant
                  </button>
                   
                </div>
                <ModalTestStatusUser
                  isOpen={openIsModalStatus}
                  closeModal={closeModalStatus}
                  statusPending={statusPending}
                  statusNotFound={statusNotFound}
                />
             
            </div>
          )
           :
          (
            <ListeCarteBancairePage
              banqueName={banqueName}
              setBanqueName={setBanqueName}
              iban={iban}
              setIban={setIban}
              setNumStep={setNumStep}
              setSelectedBnfList={setSelectedBnfList}
              selectedBnfList={selectedBnfList}
              cinBnf={bnfidentifiant}
              setCinBnf={setBnfidentifiant}
              bankcode={bankcode}
              setBankcode={setBankcode}
              swiftBic={swiftBic}
              setSwiftBic={setSwiftBic}
              functionTracks={functionTracks}
            />
          )
      }

    </div>
  )
}
export default PointCollecte
